import { NodeWorkflowState, SurveyAccount } from '@myriadgenetics/mgh-types';
import { PatientIdentifierTypes } from '../../helpers/url';

export enum SurveyContainerStep {
  Results = 'RESULTS',
  Fetch = 'FETCH',
  Lang = 'LANG',
  Survey = 'SURVEY',
  Start = 'START',
  Provider = 'PROVIDER',
  Final = 'FINAL',
  Process = 'PROCESS',
  Chatbot = 'CHAT',
  Auth = 'AUTH',
}

export interface SurveyContainerTiming {
  firstPage: string;
  end: string;
}

export interface AuthOrderData {
  firstName: string;
  lastName: string;
  dob: string;
  phone: string;
}

export interface AuthOrderDataResponse {
  url?: string;
  uuid?: string;
  error?: string | unknown;
  status?: number;
}

export interface MghOrderPatient {
  patient: {
    firstName: string;
    lastName: string;
    dob: string;
    sex: string | null;
    phone: string;
    email: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
  };
}

export interface MghOrderData {
  authCompleted: string;
  authenticated: boolean;
  clinicName: string;
  providerName: string;
  surveyEntryId: number | null;
  uuid: string;
  patient: MghOrderPatient;
}

export interface SurveyContainerLocationState {
  locSession: string;
  initData: any;
  title: string;
  surveyStep?: SurveyContainerStep;
  locSurveyId: number | null;
  survey: any;
  surveyAccount?: SurveyAccount;
  nodeId: number | null;
  locResponses: any;
  mghUrl: string;
  clinicName: string;
  timing: SurveyContainerTiming;
  accessionId: string | null;
  surveyEntryAccountId: number | null;
  resultsState: {
    nodeId: number | null;
  };
  nodeWorkFlowState: NodeWorkflowState;
  queryParams?: any;
  mghOrderData?: MghOrderData;
}

export interface BaseLocation extends Location {
  pathname: string;
  key: any;
  search: any;
}

export interface LocationState extends BaseLocation {
  state: SurveyContainerLocationState;
}

export type PatientIdentifierResponse = {
  use: PatientIdentifierTypes;
  value: string;
};
